import { ITranslations } from 'types/common';
import { CatalogueProductsTableTransFields } from './types';
import en from 'translations/en/catalogueProductsTable.json';
import pl from 'translations/pl/catalogueProductsTable.json';
import sl from 'translations/sl/catalogueProductsTable.json';

export const catalogueProductsTableTranslations: ITranslations<CatalogueProductsTableTransFields> = {
  name: 'catalogueProductsTable',
  en,
  pl,
  sl,
};
